






import SocialMediaSlider from "~/themes/fiskarsMoominDefault/components/components/molecules/SocialMediaSlider/SocialMediaSlider.vue";

export default {
  name: "MoominSocialMedia",
  components: {SocialMediaSlider},
  props: {
    siteNameId: {
      type: String,
      default: ''
    },
    containerId: {
      type: String,
      default: 'homepage'
    }
  },
}
